export default "__VITE_ASSET__0af5d896__"